import React, { useCallback, useLayoutEffect, useState } from 'react'
import style from "css/address.module.css";
import { Button, ConfigProvider, Dropdown, Input, Space, Spin, Table, Typography } from 'antd';
import { ReactComponent as Favorite } from "asset/address/favorite.svg";
import { ReactComponent as NonFavorite } from "asset/address/favorite_none.svg";
import { ReactComponent as Plus } from "asset/address/plus.svg";
import { ReactComponent as Upload } from "asset/address/upload.svg";
import { ReactComponent as Excel } from "asset/address/excel.svg";
import { ReactComponent as Edit } from "asset/address/edit.svg";
import { ReactComponent as Delete } from "asset/address/delete.svg";
import { ReactComponent as Search } from "asset/address/search.svg";
import axios from 'axios';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import Empty from 'components/address/empty';
import InfoPopup from 'components/address/infoPopup';
import ExcelPopup from 'components/address/excelPopup';
import TagPopup from 'components/address/tagPopup';
import { useTranslation } from 'react-i18next';

function Address() {
    const { t } = useTranslation();
    const [init, setInit] = useState(true);
    const [isSearch, setIsSearch] = useState(false);
    const [isSelectTag, setIsSelectTag] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [list, setList] = useState([]);
    const [selectList, setSelectList] = useState([]);
    const [tagList, setTagList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedTag, setSelectedTag] = useState("");
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupInfo, setPopupInfo] = useState(null);
    const [isUpload, setIsUpload] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [dropDownMenu, setDropDownMenu] = useState([]);
    const [isExcelDownload, setIsExcelDownload] = useState(false);
    const [isTagPopupOpen, setIsTagPopupOpen] = useState(false);

    const getList = useCallback(() => {
        setIsLoading(true);

        const config = { params: {} }

        if (searchText !== "") {
            config.params.search_text = searchText;
        }

        if (selectedTag !== "") {
            config.params.tag_id = selectedTag;
        }

        axios.get("/address/list", config)
            .then(
                res => {
                    if (res.status === 200) {
                        setList(res.data);
                    }
                }
            )
            .finally(() => {
                setIsLoading(false);
            })
    }, [searchText, selectedTag]);

    const dropDownRender = useCallback((list) => {
        let result = [];

        list.forEach(el => {
            result.push({
                key: el.key,
                label: el.label
            });
        });
        return result;
    }, []);

    const getTagList = useCallback(() => {
        const config = { params: {} }

        if (searchText !== "") {
            config.params.search_text = searchText;
        }

        axios.get("/address/tag", config)
            .then(
                res => {
                    if (res.status === 200) {
                        setTagList(res.data);
                        setDropDownMenu(dropDownRender(res.data));
                    }
                }
            )
    }, [dropDownRender, searchText]);

    useLayoutEffect(() => {
        if (init) {
            setCurrentPage(1);
            getTagList();
            getList();
            setInit(false);
        } else if (isSearch) {
            getTagList();
            getList();
            setIsSearch(false);
        } else if (isSelectTag) {
            setCurrentPage(1);
            getList();
            setIsSelectTag(false);
        }
    }, [getList, getTagList, init, isSearch, isSelectTag]);

    const updateFavorite = (key, favorite_yn) => {
        setIsLoading(true);

        const data = {
            address_id: key,
            favorite_yn: favorite_yn === 'Y' ? 'N' : 'Y'
        }

        axios.put("/address/favorite", data)
            .then(
                res => {
                    if (res.status === 200) {
                        setIsSearch(true);
                    }
                }
            )
            .finally(() => {
                setIsLoading(false);
            })
    }

    const deleteAddress = (address_id) => {
        setIsLoading(true);

        const config = {
            params: {
                address_id: address_id
            }
        }

        axios.delete("/address/info", config)
            .then(
                res => {
                    if (res.status === 200) {
                        setIsSearch(true);
                    }
                }
            )
            .finally(() => {
                setIsLoading(false);
            })
    }

    const downloadAddressToExcel = () => {
        setIsExcelDownload(true);
        const data = selectList.length > 0 ? selectList : list;
        const config = {
            responseType: "blob",
        };
        axios.post("/address/excel", data, config)
            .then((res) => {
                const url = window.URL.createObjectURL(
                    new Blob([res.data], { type: res.headers["content-type"] })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", t("LABEL.CONTACT") + ".xlsx");
                document.body.appendChild(link);
                link.click();
            })
            .finally(() => {
                setIsExcelDownload(false);
            })
    }

    const onClick = ({ key }) => {
        setSelectedTag(key);
        setInit(true);
    };

    const addAddress = () => {
        setPopupInfo(null);
        setIsPopupOpen(true);
    }

    const editAddress = (info) => {
        setPopupInfo(info);
        setIsPopupOpen(true);
    }

    const pagingChange = (page) => {
        setCurrentPage(page);
    }

    const dropdownRender = (event) => {
        const list = event.props.items;
        tagList.forEach(el => {
            list.forEach(item => {
                if (item.key === el.key) {
                    item.bg_color = el.bg_color;
                    item.txt_color = el.txt_color;
                }
            })
        });

        return (
            <section className={style.dropdown_menu}>
                <div className={style.dropdown_menu_item_area}>
                    {
                        list.map(el => (
                            <div
                                className={`${style.dropdown_menu_item} cursor`}
                                key={el.key}
                                onClick={() => onClick({ key: el.key })}
                                style={{
                                    backgroundColor: el.bg_color === undefined ? "" : el.bg_color,
                                    color: el.txt_color === undefined ? "" : el.txt_color,
                                }}
                            >
                                {el.label}
                            </div>
                        ))
                    }
                </div>

                <div
                    className={`${style.dropdown_menu_all_btn} cursor`}
                    onClick={() => onClick({ key: '' })}
                >
                    {t("LABEL.TITLE.VIEW_ALL_CONTACT")}
                </div>
            </section>
        );
    }

    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <InfoPopup
                    isOpen={isPopupOpen}
                    isRefresh={() => setIsSearch(true)}
                    closeEvent={() => setIsPopupOpen(false)}
                    openTagPopup={() => setIsTagPopupOpen(true)}
                    info={popupInfo}
                    tagList={tagList}
                />

                <ExcelPopup
                    isOpen={isUpload}
                    isRefresh={() => setIsSearch(true)}
                    closeEvent={() => setIsUpload(false)}
                />

                <TagPopup
                    isOpen={isTagPopupOpen}
                    refreshEvent={() => setIsSearch(true)}
                    closeEvent={() => setIsTagPopupOpen(false)}
                    tagList={tagList}
                />

                <section className={style.header_wrapper}>
                    <div className={style.header_container}>
                        <div className={style.header_item}>
                            <Input
                                className={style.search_input}
                                placeholder={t("PLACEHOLDER.SEARCH.MAIL_NAME")}
                                onChange={e => setSearchText(e.target.value)}
                                onKeyDown={
                                    e => {
                                        if (e.key === "Enter") {
                                            setInit(true);
                                        }
                                    }
                                }
                                suffix={
                                    <SearchOutlined
                                        className='search-btn'
                                        onClick={() => setIsSearch(true)}
                                    />
                                }
                            />

                            <Button
                                className={style.search_btn}
                                type='primary'
                                onClick={() => addAddress()}
                                icon={<Plus />}
                            >
                                {t("LABEL.TITLE.ADD_CONTACT")}
                            </Button>
                        </div>

                        <div className={style.header_item}>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            colorPrimaryHover: "#1cb691",
                                            colorPrimaryActive: "#1cb691",
                                        }
                                    }
                                }}
                            >
                                <Button
                                    className={style.excel_btn}
                                    type='default'
                                    onClick={() => downloadAddressToExcel()}
                                    icon={<Excel />}
                                    loading={isExcelDownload}
                                />
                            </ConfigProvider>

                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            colorPrimaryHover: "#1cb691",
                                            colorPrimaryActive: "#1cb691",
                                        }
                                    }
                                }}
                            >
                                <Button
                                    className={style.upload_btn}
                                    type='default'
                                    onClick={() => setIsUpload(true)}
                                    icon={<Upload />}
                                >
                                    {t("BTN.UPLOAD")}
                                </Button>
                            </ConfigProvider>
                        </div>
                    </div>
                </section>

                <section className={style.body_wrapper}>
                    <div className={style.body_container}>
                        {
                            init
                                ?
                                <Spin />
                                :
                                <ConfigProvider
                                    theme={{
                                        token: {
                                            colorFillAlter: "#fff",
                                            fontFamily: "Spoqa Han Sans Neo",
                                            controlItemBgActive: "#eef5db",
                                            controlItemBgActiveHover: "#eef5db",
                                            controlItemBgHover: "#eef5db",
                                            colorBorderSecondary: "#f6f6f6",
                                        },
                                        components: {
                                            Checkbox: {
                                                controlInteractiveSize: 20,
                                                colorPrimaryActive: "#1cb691",
                                                colorPrimary: "#1cb691",
                                                colorPrimaryHover: "#1cb691"
                                            },
                                        }
                                    }}
                                >
                                    <Table
                                        columns={[
                                            {
                                                dataIndex: 'favorite',
                                                key: 'favorite',
                                                align: 'center',
                                                width: '5%',
                                                render: (_, { key, favorite }) => (
                                                    <div
                                                        className={`${style.favorite_btn} cursor`}
                                                        onClick={() => updateFavorite(key, favorite)}
                                                    >
                                                        {
                                                            favorite === 'Y'
                                                                ? <NonFavorite />
                                                                : <Favorite />
                                                        }
                                                    </div>
                                                ),
                                            },
                                            {
                                                title: t("LIST.NAME"),
                                                dataIndex: 'name',
                                                key: 'name',
                                                align: 'left',
                                                width: '15%',
                                                sorter: (a, b) => a.name.localeCompare(b.name),
                                                showSorterTooltip: false
                                            },
                                            {
                                                title: t("LIST.EMAIL"),
                                                dataIndex: 'email',
                                                key: 'email',
                                                align: 'center',
                                                width: '20%',
                                                sorter: (a, b) => a.email.localeCompare(b.email),
                                                showSorterTooltip: false
                                            },
                                            {
                                                title: t("LIST.PHONE"),
                                                dataIndex: 'tel',
                                                key: 'tel',
                                                align: 'center',
                                                width: '15%',
                                                sorter: (a, b) => a.tel.localeCompare(b.tel),
                                                showSorterTooltip: false
                                            },
                                            {
                                                title: () => (
                                                    <ConfigProvider
                                                        theme={{
                                                            components: {
                                                                Typography: {
                                                                    colorText: "#000 !important",
                                                                },
                                                                Dropdown: {
                                                                    colorBgBase: "#fff",
                                                                    boxShadowSecondary: '0 2px 10px 0 rgba(0, 0, 0, 0.15) !important',
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <Dropdown
                                                            menu={{
                                                                items: dropDownMenu,
                                                                onClick
                                                            }}
                                                            trigger={['click']}
                                                            dropdownRender={dropdownRender}
                                                        >
                                                            <Typography.Link>
                                                                <Space>
                                                                    {t("LIST.TYPE")}
                                                                    <DownOutlined />
                                                                </Space>
                                                            </Typography.Link>
                                                        </Dropdown>
                                                    </ConfigProvider>
                                                ),
                                                dataIndex: 'gubun',
                                                key: 'gubun',
                                                align: 'left',
                                                width: '30%',
                                                render: (_, { tag }) => (
                                                    <div className={style.tag_area}>
                                                        {tag.map((el) => {
                                                            const match = tagList.filter(item => item.label === el)[0];
                                                            if (match === undefined) {
                                                                return null;
                                                            } else {
                                                                return (
                                                                    <div
                                                                        className={style.tag_item}
                                                                        style={{
                                                                            backgroundColor: match.bg_color === undefined ? "" : match.bg_color,
                                                                            color: match.txt_color === undefined ? "" : match.txt_color,
                                                                        }}
                                                                        key={el}
                                                                    >
                                                                        {el}
                                                                    </div>
                                                                );
                                                            }
                                                        })}
                                                    </div>
                                                ),
                                            },
                                            {
                                                title: '',
                                                dataIndex: '',
                                                align: 'center',
                                                key: 'FUNC',
                                                width: '10%',
                                                render: (_, el) => (
                                                    <Space size="middle">
                                                        <Edit
                                                            className='cursor'
                                                            onClick={() => editAddress(el)}
                                                        />
                                                        <Delete
                                                            className={`${style.delete_btn} cursor`}
                                                            onClick={() => deleteAddress(el.key)}
                                                        />
                                                    </Space>
                                                ),
                                            }
                                        ]}
                                        dataSource={list}
                                        locale={{
                                            emptyText:
                                                isLoading
                                                    ? <></>
                                                    : <Empty description={t("MESSAGE.NO_DATA")} />,
                                        }}
                                        loading={isSearch || isSelectTag || isLoading}
                                        pagination={{
                                            position: ['bottomRight'],
                                            pageSize: 10,
                                            total: list.length,
                                            responsive: true,
                                            showSizeChanger: false,
                                            current: currentPage,
                                            onChange: pagingChange
                                        }}
                                        rowSelection={{
                                            columnWidth: "5%",
                                            onChange: (keys, rows, info) => { setSelectList(rows) }
                                        }}
                                    />
                                </ConfigProvider>
                        }
                    </div>
                </section>
            </div >
        </div >
    )
}

export default Address
